<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()" [isDashboard]="true"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Dashboard ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showDashboardDataTable">

<div class="fullpart" *ngIf="!isCoLogin()">
  <form [formGroup]="filterForm" class="formWidth1" #formDirective="ngForm" (ngSubmit)="addFilter(formDirective)">


  </form>
  </div>


  <!-- <input class="date" type="month" id="start" name="start" min="2022-01" [max]="maxDate"  [(ngModel)]="currentDate" #date1>

  <button class="ml-10px mybutton" (click)="submitDates()">Submit</button> -->
  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img
      src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px"
      (click)="closeButtonClick()">
  </span>





  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>

  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Name of the<br>Borrower</th>
          <th>Account <br> No.</th>
          <th>Sanctioned<br>Limit</th>
          <th>Due date <br> of Renewal</th>
          <th>Existing <br> DP</th>
          <!-- <th>Proposed <br> DP</th> -->
          <th>Consent <br> Status</th>
          <th>Land Record <br> Updation</th>
          <th>Processing<br> Status</th>
          <!-- <th>CBS<br> Status</th> -->
          <th>CBS <br>Status</th>

        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let user of allUsers;let i = index;">

          <td class="vertical-align-middle">
            <p>{{10 *(pageId-1)+i+1}}</p>
          </td>
          <td class="vertical-align-middle w-16pct">
            <p>{{user?.profile?.name}}</p>
          </td>
          <td>
            <p>{{user?.user_docs?.kcc_acc_no_unMasked}}</p>
          </td>
          <td>
            <p>{{user?.user_docs?.existing_loan_details.existing_limit}}</p>
          </td>
          <td>
            <p>{{user?.user_docs?.renewal_duedate_for_credit_limit}}</p>
          </td>
          <td>
            <!-- {{user?.final_form_submitted_data?.proposed_dp_k}} -->
            <p>{{user?.user_docs?.existing_dp}}</p>
          </td>
          <!-- <td><p>{{user?.user_docs?.proposed_dp?user?.user_docs?.proposed_dp:"Not available"}}</p></td> -->


          <td (click)="openConsent(user.id,user.consent_feedback_status)">
            <!-- <td  (click)="openConsent(user.id,user.consent_feedback_status)"> -->
            <div>
              <p [ngStyle]="getConsentStyle(i)"><b>{{checkConsentStatus(i)}}</b></p>
            </div>
            <!-- <div ><p class="text-center"><b>{{checkConsentStatus(i)}}</b></p></div> -->
          </td>
          <td [ngStyle]="getLRStyle(i)" (click)="openLandRecords(user.id, user.custId)">
            <p><b>{{checkforlandrecordstatus(i)}}</b></p>
          </td>
          <td>
            <!-- <p>{{user?.bre_status?user?.bre_status:"In Process"}}</p> -->
            <p>{{getProcessingStatus(i)}}</p>
          </td>
          <!-- <td>
            <p>{{checkforrepaymentstatus(i)}}</p>
          </td> -->
          <!-- <td>
            <p>CBS status</p>
          </td> -->
          <td>
            <p>{{user?.cbs_auto_renewal_status=="A"?"Approved":"Pending"}}</p>
          </td>


        </tr>
      </tbody>
    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>


</wl-card>





<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />

<!-- <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"> -->